import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { SchedaUtenza } from './SchedaUtenza';
import { IndirizziBloccati } from './IndirizziBloccati';

const INTESTAZIONI: Record<string, string> = {
  Nome: 'Nome e cognome',
  CostoOrario: 'Costo orario',
  CreatoIl: 'Creata il',
};

const COLONNE = [
  'Codice',
  'Nome',
  'Ruolo',
  'Sede',
  'CostoOrario',
  'Attivo',
  'Rapportini',
  'Documenti',
];

/*  Le utenze di TeraWorks.

    Prima di questa schermata i ruoli si assegnavano con una UPDATE sul database del
    cliente: per far entrare una persona serviva chi ha accesso a SQL Server, e
    l'assegnazione di un permesso non lasciava traccia di chi l'aveva decisa.

    «nuova» come identificativo di selezione, invece di un secondo stato booleano: la
    scheda è la stessa per la creazione e per la modifica, quindi lo stato è uno —
    «cos'è aperto» — e ha tre valori invece di due combinazioni da tenere coerenti.
*/
export function ElencoUtenze() {
  const [aperta, setAperta] = useState<string | 'nuova' | null>(null);
  const [versione, setVersione] = useState(0);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Utenze</h1>
            <p>
              Chi entra in TeraWorks e cosa può fare. Il ruolo non è un'etichetta: è
              quello che determina i permessi, quindi cambiarlo cambia subito cosa quella
              persona vede e può premere — alla richiesta successiva, non al prossimo
              accesso.
            </p>
            <p className="nota">
              L'elenco apre sulle utenze <strong>attive</strong>. Nessuno si cancella: le
              ore registrate e i documenti firmati devono continuare a mostrare il nome di
              chi li ha fatti, e le due colonne di conteggio dicono quanti sono. Il filtro
              si toglie con un clic per ritrovare chi è stato disattivato.
            </p>
          </div>
          <button type="button" className="primario" onClick={() => setAperta('nuova')}>
            Nuova utenza
          </button>
        </header>

        <IndirizziBloccati />

        <DataGrid
          nomeGriglia="utenti"
          versione={versione}
          colonneVisibili={COLONNE}
          intestazioni={INTESTAZIONI}
          idSelezionato={aperta === 'nuova' ? null : aperta}
          onRigaSelezionata={(riga) => {
            const id = riga['Id'];
            if (typeof id === 'string') setAperta(id);
          }}
        />
      </div>

      {aperta !== null && (
        <SchedaUtenza
          utenzaId={aperta === 'nuova' ? null : aperta}
          onChiudi={() => setAperta(null)}
          onCambiata={() => setVersione((v) => v + 1)}
        />
      )}
    </section>
  );
}
